import { CLEAR_TOAST } from '../types';

const clearToast = id => dispatch => {
  dispatch({
    type: CLEAR_TOAST,
    id
  });
};

export default clearToast;